import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CookieService } from '@eceos/common-components';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  template: `
    <ngx-loading-bar [includeSpinner]="false" height="3px"></ngx-loading-bar>
    <input type="text" style="display:none" />
    <input type="password" style="display:none" />
    <router-outlet></router-outlet>
  `
})
export class AppComponent implements OnInit {
  private readonly defaultTitle = 'e-Ceos PDV';

  constructor(
    private router: Router,
    private title: Title,
    private activatedRoute: ActivatedRoute,
    private cookieService: CookieService
  ) {}

  ngOnInit(): void {
    this.cookieService.checkCookieConsent();
  
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          const child = this.activatedRoute.firstChild;
          const titleParam = child.snapshot.data['title']
          if (titleParam) {
            return titleParam;
          }
          return this.defaultTitle;
        })
      )
      .subscribe((ttl: string) => this.title.setTitle(ttl));
  }
}
